var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHide = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2,
    fill: "currentColor",
    stroke: "currentColor",
    className: "nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    "data-cap": "butt",
    d: "M8.373,23.627a27.659,27.659,0,0,1-6.958-6.445,1.938,1.938,0,0,1-.008-2.37C3.428,12.162,8.892,6,16.006,6a14.545,14.545,0,0,1,7.626,2.368",
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,10.923a30.256,30.256,0,0,1,3.591,3.887,1.937,1.937,0,0,1,0,2.38C28.542,19.842,23.026,26,16.006,26A12.843,12.843,0,0,1,12,25.341",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-color": "color-2",
    "data-cap": "butt",
    d: "M11.764,20.243a6,6,0,0,1,8.482-8.489",
    fill: "none",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-color": "color-2",
    d: "M21.923,15a6.005,6.005,0,0,1-5.917,7A6.061,6.061,0,0,1,15,21.916",
    fill: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    "data-color": "color-2",
    x1: 2,
    y1: 30,
    x2: 30,
    y2: 2,
    fill: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHide);
export default ForwardRef;